/* prettier-ignore */
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { OfflineDetectionService } from '../services';

export const offlineRouteGuard: CanMatchFn = () => {
  const offlineDetection = inject(OfflineDetectionService);
  const router = inject(Router);

  if (offlineDetection.isOnline())
    return true;

  return router.parseUrl('/offline-routes');
};
